import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Phonics Grand Prix',
    description: 'A 3D phonics racing adventure for Year 1 pupils. Explore the island, blend CVC words, fix your race car and win the Grand Prix.',
    placeholder: 'Loading Phonics Racing Island',
    url: getOrigin()
}
